import React from 'react';

import { Input } from './ui/input';
import { Label } from './ui/label';
import { UK_COUNTIES, countiesFor } from '../lib/counties';

/**
 * The county control — ONE of them, for every screen that asks.
 *
 * ⚠️ ROB SPOTTED THE SPLIT, 08/08/2026: *"The County box in settings → Company Details is
 * not a drop down like the one in Locations, but they do update each other."* Two doors
 * onto the same field, offering different vocabularies. Worse, there were **three** copies
 * of the county list in the codebase and three counties were spelled differently between
 * them (Durham / County Durham, Orkney Islands / Orkney, Shetland Islands / Shetland).
 *
 * ⚠️ AN UNRECOGNISED COUNTY IS KEPT, NOT DISCARDED. Existing data may hold a spelling
 * that isn't in the list — including anything typed on the old free-text box — and a
 * select that silently drops it would blank somebody's address the next time they saved
 * an unrelated field. It is added as its own option instead.
 */
// `className` / `controlClassName` let a compact form put the label beside the box (the Location
// box, 03/11/2026); left out, it looks exactly as it always has.
const CountyField = ({ countryCode, value, onChange, id = 'county', labelClassName, className, controlClassName = 'mt-1' }) => {
  const options = countiesFor(countryCode);
  const controlled = options.length > 0;

  return (
    <div className={className}>
      <Label htmlFor={id} className={labelClassName}>
        {/* Outside the UK "county" is the wrong word about as often as it is the right
            one, so the label says what the box is actually for. */}
        {controlled ? 'County' : 'County / state / province'}
      </Label>
      {controlled ? (
        <select
          id={id}
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          className={`input-hive hh-select ${controlClassName}`}
        >
          <option value="">Select county…</option>
          {value && !UK_COUNTIES.includes(value) && (
            <option value={value}>{value}</option>
          )}
          {options.map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
      ) : (
        <Input
          id={id}
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder="State, province or region"
          className={`input-hive ${controlClassName}`}
        />
      )}
    </div>
  );
};

export default CountyField;
